import { AppWindow } from '../../definitions/AppWindow';

declare let window: AppWindow;

export function checkUseClientSideRouting(evt, node) {
  if (window?.cwClientSideRouteTo) {
    // this is set by the domain app
    evt.preventDefault();
    window?.cwClientSideRouteTo(node.getAttribute('href'));
  }
}

export function initSubnavItems() {
  [...document.querySelectorAll('.cw_navbar__subnav-item')].forEach((node) => {
    if (!node.getAttribute('data-initialized')) {
      node.addEventListener('click', (evt) => checkUseClientSideRouting(evt, node));
      node.setAttribute('data-initialized', 'true');
    }
  });
}

export function isAppDownloadDesktopBanner() {
  const banner = document.getElementById('PPAppDownloadBanner_Desktop');
  return banner && window.getComputedStyle(banner).display !== 'none';
}

export function loadDeferredImages() {
  const images = document.querySelectorAll('[data-cw-img-src]');
  for (const img of images) {
    const src = img.getAttribute('data-cw-img-src');
    img.setAttribute('src', src);
  }
}

/**
 * Function to handle events and tracking for app download desktop banner
 */
export function initAppDownload() {
  if (isAppDownloadDesktopBanner()) {
    const bannerClose = document.getElementById('PPAppDownloadBannerCloseIcon');
    const ppDesktopBannerContainer = document.getElementById('PPAppDownloadBanner_Desktop');

    bannerClose?.addEventListener('click', function (e) {
      e.preventDefault();
      ppDesktopBannerContainer.style.display = 'none';
      document.body.classList.remove('PP__DesktopBanner');

      const containerSpaceClassList = document.querySelectorAll('.PP__DesktopBanner__Top_Margin');

      for (const node of containerSpaceClassList) {
        node.classList.remove('PP__DesktopBanner__Top_Margin');
      }
    });
  }
}

export default function () {
  window.cwEnableSubnav = () => {
    document.body.classList.add('cw_navbar--enable-subnav');
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('.cw_navbar')) {
      return;
    }
    document.body.classList.add('cw_navbar_enabled');

    loadDeferredImages();
    // Update top position of app container to keep the banner sticky with nav header
    if (isAppDownloadDesktopBanner() && !document.body.classList.contains('PP__DesktopBanner')) {
      document.body.classList.add('PP__DesktopBanner');
    }
  });

  window.addEventListener('load', () => {
    if (!document.querySelector('.cw_navbar')) {
      return;
    }
    initSubnavItems();
    initAppDownload();
  });
}
